var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bl-client-targets-panel" },
    [
      _c("div", { staticClass: "bl-targets-header" }, [
        _c(
          "div",
          { staticClass: "bl-targets-name" },
          [
            _c("BlTextTitle4", { attrs: { text: "Targets" } }),
            _vm._v(" "),
            _c("BlBubbleCount", { attrs: { count: _vm.totalTargets || 0 } })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "bl-targets-description" },
          [
            _c("BlTextBody2", {
              attrs: {
                text:
                  "Create targets tailored to your clients and use them in their sessions."
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "relative flex items-center gap-4" },
          [
            _c("BlInputButton", {
              staticClass: "flex-grow",
              attrs: {
                label: "Create new target",
                icon: "plus",
                disabled: _vm.hasTargetJob
              },
              on: {
                clicked: function($event) {
                  return _vm.$emit("toggle-new-target-opened", true)
                }
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "flex items-center justify-center flex-shrink-0 w-10 h-full rounded cursor-pointer bg-light-purple",
                class: [
                  _vm.hasTargetJob
                    ? "pointer-events-none opacity-25"
                    : "hover:bg-dark-purple-200"
                ],
                attrs: { disabled: _vm.hasTargetJob },
                on: {
                  click: function($event) {
                    _vm.menuOpened = !_vm.menuOpened
                  }
                }
              },
              [
                _c("BlIcon", {
                  staticClass: "w-6 h-6 transition-all duration-300",
                  style: { rotate: _vm.menuOpened ? "180deg" : "" },
                  attrs: { icon: "chevron-down", color: "secondary" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.menuOpened
              ? _c(
                  "div",
                  {
                    staticClass:
                      "absolute right-0 z-50 p-1 mt-2 space-y-1 border rounded top-full bg-pure-white border-grey-200",
                    on: {
                      click: function($event) {
                        _vm.menuOpened = false
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "px-4 py-2 text-left rounded cursor-pointer hover:bg-hover-state min-w-32",
                        on: {
                          click: function($event) {
                            _vm.addTargetFromCurriculaOpened = true
                          }
                        }
                      },
                      [
                        _c("BlTextBody2", {
                          staticClass: "text-slate-1000",
                          attrs: { text: "Add targets from curricula" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "px-4 py-2 text-left rounded cursor-pointer hover:bg-hover-state min-w-32",
                        on: {
                          click: function($event) {
                            _vm.addTargetFromDatabankOpened = true
                          }
                        }
                      },
                      [
                        _c("BlTextBody2", {
                          staticClass: "text-slate-1000",
                          attrs: { text: "Add targets from databank" }
                        })
                      ],
                      1
                    )
                  ]
                )
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "bl-targets-search" },
          [
            _c("BlInputSearch", {
              staticClass: "w-full",
              attrs: { input: _vm.searchInput },
              on: { changed: _vm.inputHandler }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "grid w-full grid-cols-2 gap-4" },
          [
            _c("BlInputFilter", {
              staticClass: "bl-targets-header-filter",
              attrs: { input: _vm.filterInput },
              on: { changed: _vm.inputHandler }
            }),
            _vm._v(" "),
            _c("BlInputSelect", {
              staticClass: "bl-targets-header-filter",
              attrs: { input: _vm.sortInput },
              on: { changed: _vm.inputHandler }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "bl-targets-body" },
        [
          _vm.loading
            ? _c(
                "div",
                { staticClass: "absolute z-10 w-full h-full -mx-6 -my-6" },
                [
                  _c("div", {
                    staticClass:
                      "absolute w-full h-full opacity-75 bg-pure-white"
                  }),
                  _vm._v(" "),
                  _vm._m(0)
                ]
              )
            : !_vm.targets.length
            ? _c(
                "div",
                {
                  staticClass:
                    "flex items-center justify-center h-full text-sm text-grey-400"
                },
                [
                  _c("BlTextBody1", { attrs: { text: "Target(s) not found." } })
                ],
                1
              )
            : _vm._l(_vm.targets, function(item) {
                return _c("TargetCard", {
                  key: item.id,
                  staticClass: "bl-client-target",
                  class: {
                    "my-2": item.target_tasks && item.target_tasks.length > 0
                  },
                  attrs: {
                    useAction: "",
                    target: item,
                    activeTask: _vm.activeTask,
                    active: _vm.target ? _vm.target.id === item.id : false
                  },
                  on: {
                    clicked: function($event) {
                      return _vm.onSelectTarget(item.id)
                    },
                    clickedTask: _vm.onSelectTargetTasks,
                    delete: function($event) {
                      _vm.deleteOpened = item.id
                    }
                  }
                })
              })
        ],
        2
      ),
      _vm._v(" "),
      _vm.newTargetOpened
        ? _c("NewTargetOverlay", {
            attrs: {
              description: "Create a new target tailored for your clients.",
              clientId: _vm.id,
              kind: "client"
            },
            on: {
              "close-modal": function($event) {
                return _vm.$emit("toggle-new-target-opened", false)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.addTargetFromCurriculaOpened
        ? _c("AddTargetFromCurriculaModal", {
            on: {
              "close-modal": function($event) {
                _vm.addTargetFromCurriculaOpened = false
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.addTargetFromDatabankOpened
        ? _c("AddTargetFromDatabankModal", {
            on: {
              "close-modal": function($event) {
                _vm.addTargetFromDatabankOpened = false
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.deleteOpened > -1
        ? _c("BlBackdrop", {
            attrs: {
              title: "Delete target",
              label: "Delete the target",
              description:
                "You are about to delete the target. Are you sure you want to proceed? This action is irreversible.",
              type: "error",
              empty: ""
            },
            on: {
              "backdrop-close": function($event) {
                _vm.deleteOpened = -1
              },
              "backdrop-action": _vm.onRemoveTarget
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "absolute z-10 grid w-full h-full place-items-center" },
      [_c("div", { staticClass: "blum-loader" })]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4942221d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4942221d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clients/target/Panel.vue
// module id = null
// module chunks = 